var _rect, _circle, _ellipse, _circle2, _circle3, _circle4, _mask, _path, _mask2, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup523(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.91895,
    y: 16.1216,
    width: 30.1628,
    height: 14.6512,
    stroke: "url(#paint0_linear_366_564)",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.50035,
    cy: 17.704,
    r: 2.94186,
    transform: "rotate(41.3885 9.50035 17.704)",
    fill: "url(#paint1_linear_366_564)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.1308,
    cy: 23.8552,
    rx: 4.58793,
    ry: 4.6995,
    transform: "rotate(41.3885 23.1308 23.8552)",
    fill: "url(#paint2_linear_366_564)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0352,
    cy: 28.9365,
    r: 2.94186,
    transform: "rotate(-27.0563 10.0352 28.9365)",
    fill: "url(#paint3_linear_366_564)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.0503,
    cy: 28.7425,
    r: 2.94186,
    transform: "rotate(12.2217 36.0503 28.7425)",
    fill: "url(#paint4_linear_366_564)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1257,
    cy: 18.1195,
    r: 2.94186,
    transform: "rotate(-42.6553 36.1257 18.1195)",
    fill: "url(#paint5_linear_366_564)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_366_564",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4138 23.7146C45.7375 23.7146 46.0008 23.9771 45.9925 24.3007C45.9206 27.1214 45.3303 29.9065 44.2492 32.5163C43.0934 35.3068 41.3992 37.8423 39.2635 39.9781C37.1277 42.1138 34.5922 43.808 31.8017 44.9638C29.0112 46.1197 26.0204 46.7146 23 46.7146C19.9796 46.7146 16.9888 46.1197 14.1983 44.9638C11.4078 43.808 8.87229 42.1138 6.73654 39.9781C4.6008 37.8423 2.90663 35.3068 1.75077 32.5163C0.669735 29.9065 0.0793716 27.1214 0.00746951 24.3007C-0.000780651 23.9771 0.26245 23.7146 0.586199 23.7146C0.909947 23.7146 1.17158 23.9771 1.18027 24.3007C1.2519 26.9674 1.81181 29.6001 2.83392 32.0677C3.93086 34.7159 5.53867 37.1222 7.56555 39.149C9.59243 41.1759 11.9987 42.7837 14.6469 43.8807C17.2952 44.9776 20.1336 45.5422 23 45.5422C25.8664 45.5422 28.7048 44.9776 31.3531 43.8807C34.0013 42.7837 36.4076 41.1759 38.4344 39.149C40.4613 37.1222 42.0691 34.7159 43.1661 32.0677C44.1882 29.6001 44.7481 26.9674 44.8197 24.3007C44.8284 23.9771 45.0901 23.7146 45.4138 23.7146Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4138 23.7146C45.7375 23.7146 46.0008 23.9771 45.9925 24.3007C45.9206 27.1214 45.3303 29.9065 44.2492 32.5163C43.0934 35.3068 41.3992 37.8423 39.2635 39.9781C37.1277 42.1138 34.5922 43.808 31.8017 44.9638C29.0112 46.1197 26.0204 46.7146 23 46.7146C19.9796 46.7146 16.9888 46.1197 14.1983 44.9638C11.4078 43.808 8.87229 42.1138 6.73654 39.9781C4.6008 37.8423 2.90663 35.3068 1.75077 32.5163C0.669735 29.9065 0.0793716 27.1214 0.00746951 24.3007C-0.000780651 23.9771 0.26245 23.7146 0.586199 23.7146C0.909947 23.7146 1.17158 23.9771 1.18027 24.3007C1.2519 26.9674 1.81181 29.6001 2.83392 32.0677C3.93086 34.7159 5.53867 37.1222 7.56555 39.149C9.59243 41.1759 11.9987 42.7837 14.6469 43.8807C17.2952 44.9776 20.1336 45.5422 23 45.5422C25.8664 45.5422 28.7048 44.9776 31.3531 43.8807C34.0013 42.7837 36.4076 41.1759 38.4344 39.149C40.4613 37.1222 42.0691 34.7159 43.1661 32.0677C44.1882 29.6001 44.7481 26.9674 44.8197 24.3007C44.8284 23.9771 45.0901 23.7146 45.4138 23.7146Z",
    stroke: "url(#paint6_linear_366_564)",
    strokeWidth: 10,
    strokeLinecap: "square",
    mask: "url(#path-7-inside-1_366_564)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_366_564",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9826 24.6078C46.1654 19.906 44.9016 15.2612 42.3618 11.3001C39.8221 7.33903 36.1285 4.25222 31.7793 2.45612C27.4302 0.660017 22.6349 0.241052 18.0402 1.25574C13.4455 2.27043 9.27257 4.66996 6.08436 8.1306L6.96272 8.93982C9.98538 5.65887 13.9416 3.38395 18.2977 2.42195C22.6538 1.45994 27.2002 1.85715 31.3235 3.55999C35.4468 5.26283 38.9485 8.18935 41.3565 11.9448C43.7644 15.7002 44.9625 20.1038 44.7892 24.5615L45.9826 24.6078Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9826 24.6078C46.1654 19.906 44.9016 15.2612 42.3618 11.3001C39.8221 7.33903 36.1285 4.25222 31.7793 2.45612C27.4302 0.660017 22.6349 0.241052 18.0402 1.25574C13.4455 2.27043 9.27257 4.66996 6.08436 8.1306L6.96272 8.93982C9.98538 5.65887 13.9416 3.38395 18.2977 2.42195C22.6538 1.45994 27.2002 1.85715 31.3235 3.55999C35.4468 5.26283 38.9485 8.18935 41.3565 11.9448C43.7644 15.7002 44.9625 20.1038 44.7892 24.5615L45.9826 24.6078Z",
    stroke: "url(#paint7_linear_366_564)",
    strokeWidth: 10,
    strokeLinecap: "square",
    mask: "url(#path-8-inside-2_366_564)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97016 12.7214L4.94412 5.40598L10.0888 10.1259L2.97016 12.7214Z",
    fill: "url(#paint8_linear_366_564)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_366_564",
    x1: 6.68379,
    y1: 15.1158,
    x2: 41.3626,
    y2: 22.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_366_564",
    x1: 6.60548,
    y1: 14.9269,
    x2: 12.9766,
    y2: 15.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_366_564",
    x1: 18.6162,
    y1: 19.4188,
    x2: 28.5587,
    y2: 20.5768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_366_564",
    x1: 7.14033,
    y1: 26.1594,
    x2: 13.5115,
    y2: 26.9195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_366_564",
    x1: 33.1554,
    y1: 25.9654,
    x2: 39.5265,
    y2: 26.7254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_366_564",
    x1: 33.2308,
    y1: 15.3424,
    x2: 39.6019,
    y2: 16.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_366_564",
    x1: 0.367361,
    y1: 2.0026,
    x2: 50.178,
    y2: 7.94502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_366_564",
    x1: 0.367361,
    y1: 2.0026,
    x2: 50.178,
    y2: 7.94502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_366_564",
    x1: 6.06272,
    y1: 15.2179,
    x2: 0.247428,
    y2: 8.60858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#F2942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#ED6E18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup523);
export default __webpack_public_path__ + "static/media/Group 523.15ce92493e302d92e65244f018bee74f.svg";
export { ForwardRef as ReactComponent };